<template>
  <div id="app" style="position: relative">
    <div class="header">
      <notices></notices>
      <menus></menus>
    </div>
    <div class="ls-gg" v-if="ad_info">
    <div v-html="ad_info"></div>
    </div>
    <router-view/>
    <div class="footer">
      <div class="copy-right">
        Copyright ©2018 www.caixun.com All rights reserved 彩讯开奖网 版权所有
      </div>
      <div class="friends-link"><img width="100%" src="./assets/footer.png"></div>
    </div>
  </div>
</template>

<script>
import notices from '@/components/Notices'
import menus from '@/components/Menu'
export default {
  name: 'App',
  data: function () {
    return {
      ad_info: ''
    }
  },
  mounted: function(){
    this.getAdvert();
  },
  components: {
    notices,
    menus
  },
  methods: {
    getAdvert(){
        let self = this;
        this.$api.getAdvert()
        .then(function(res) {
          if(res.data){
            if(res.data.length > 0){
              self.ad_info = res.data;
            }
          }
        })
        .catch(function(res) {
          console.log('服务器内部错误');
        })
      },
  }
}
</script>

<style>
  * {
    margin: 0;
    padding: 0;
  }
  /*<1024的设备*/
  @media screen and (max-width: 1024px){
    body{
      width: 1024px;
    }
    #app {
      width: 1024px;
      background: url(./assets/back.jpg) no-repeat;
      background-size: 1024px 100%;
    }
  }
  /*>=1024的设备*/
  @media screen and (min-width: 1024px){
    body{
      overflow-x: hidden; 
      width: 100%;
    }
    #app {
      width: 100%;
      background: url(./assets/back.jpg) no-repeat;
      background-size: 100% 100%;
    }
  } 
  @media screen and (max-width: 1281px){
    .ls-gg {
      width: 1024px;
      margin: auto;
    } 
  }
  @media screen and (min-width: 1281px){
   .ls-gg {
      width: 1280px;
      margin: auto;
    } 
  }
  .footer {
    clear: both;
    padding-top: 50px;
  }
  .copy-right{
    text-align: center;
    width: 100%;
    height: 50px;
    background-color: #bebebe;
    font-size: 13px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 50px;
    letter-spacing: 0px;
    color: #ffffff;

  }
  .friends-link{
    width: 100%;
    height: 136px;
    background-color: #ffffff;
    opacity: 0.8;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue